<div
  class="image-container container"
  style="background-image: url('/assets/images/lifestyle/galerie.jpg')"
>
  <h3
    class="title"
  >
    Living by nature
  </h3>
</div>

<div
  class="container"
>
  <div class="downtown-description gallery-description">
    <img class="title-decoration" src="/assets/icons/lifestyle/frunza.svg">
    <p translate>
      pages.downtown_life.gallery.paragraph
    </p>
    <img class="title-decoration" src="/assets/icons/lifestyle/frunza.svg">
  </div>
</div>

<div
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  class="container images-container"
>
  <app-images-carousel-base
    [images]="apImages"
  >
  </app-images-carousel-base>
</div>

<div
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  class="container images-container"
>
  <app-images-carousel-base
    [images]="interiorImages"
    class="images-slider"
  >
  </app-images-carousel-base>
  <app-images-carousel-base
    [images]="exteriorImages"
    class="images-slider"
  >
  </app-images-carousel-base>
</div>



// WEBPACK FOOTER //
// ./src/app/downtown-life/gallery.component.html